<script>
import { mapActions } from 'vuex';
import BaseAutocompleteSearchRequestFilter from '@/modules/_global/_components/filters/BaseAutocompleteSearchRequestFilter.vue';

export default {
  name: 'ManagementCompaniesFilter',

  extends: BaseAutocompleteSearchRequestFilter,

  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(v) {
        this.getDataDebounced(v);
      }
    }
  },

  methods: {
    ...mapActions('building_complex', ['getFilteredManagementCompanies']),

    getData(search) {
      return this.getFilteredManagementCompanies({ search }).then(
        ({ data }) => {
          return data.data;
        }
      );
    }
  }
};
</script>
